import { Injectable } from "@angular/core";
import { delay, retryWhen, tap} from 'rxjs/operators';
import {Observable, throwError} from 'rxjs';
import {of } from 'rxjs/internal/observable/of';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpResponse, HttpErrorResponse } from "@angular/common/http";
import {concatMap} from 'rxjs/internal/operators/concatMap';

import {Router} from '@angular/router';
import {GlobalEventsManager} from '../GlobalEventManager';

@Injectable()
export class MyHttpInterceptor implements HttpInterceptor {
  constructor(private globalEventsManager: GlobalEventsManager, private router: Router) { }
  //function which will be called for all http calls

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {

    this.globalEventsManager.showSpinner.emit(true);

    //on login the session token is null, we need to at least init the value
    var storedToken = sessionStorage.getItem("token");
    if(storedToken==null){
      storedToken = " ";
    }

  //  console.log("Before Spinner");
    //how to update the request Parameters
    const updatedRequest = request.clone({
      headers: request.headers.set("Authorization", storedToken).set("Content-Type", "application/json")
      //headers: request.headers.set("Authorization",  sessionStorage.getItem("token")).set("Content-Type", "application/json")
      //  headers: request.headers.set("Content-Type", "application/json")
    });
    //logging the updated Parameters to browser's console
    // console.log("Before making api call : ", updatedRequest);
    let retries = 1;
    return next.handle(updatedRequest).pipe(retryWhen((error) => {
        return error.pipe(
          concatMap((e, i) => {

            if (i >= retries) {
              return throwError({ ...e });
            }
            //        console.log("After Spinner");
            if (e instanceof HttpErrorResponse) {
              if (e.status == 401 || e.status == 403) { //server throws this if no valid token
                //this.myApp.openDialog("401 Server Error"+e.status);
     //           console.log("After Spinner");
                sessionStorage.setItem('token',"");
                return this.router.navigate([""]);
             //  window.location.reload();
              }
            }
            return of(e).pipe(tap(() => console.log(e)), delay(1000 as number));
          })
        );

      }),
      tap(
        event => {

          //logging the http response to browser's console in case of a success
          if (event instanceof HttpResponse) {
  //          console.log("After Spinner");
            //if the authorization token it is in header, store it, user is logging in
            if(event.headers.get("Authorization")!=null) {
              sessionStorage.setItem('token', event.headers.get("Authorization"));

            }
          }
        },
        error => {
          this.globalEventsManager.showSpinner.emit(false);
          //       console.log("After Spinner");
         // this.myApp.openDialog("401 Server Error"+error.status);
          console.log("Error happened :"+ error.status);
          //logging the http response to browser's console in case of a failuer

          if (error.status == 401 || error.status == 403) { //server throws this if no valid token
         //   this.myApp.openDialog("401 Server Error"+error.status);
            sessionStorage.setItem('token',"");
      //      console.log("After Spinner");
            return this.router.navigate([""]);
         //   window.location.reload();
            // this.globalEventsManager.reloadApplication.emit(true);
           //   location.reload(); //this will reload the whole application.
          }

        },//this will never happen if error
        ()=>{
            this.globalEventsManager.showSpinner.emit(false);
        }
      )
    );
  }
}
